angular.module('app').directive('menuSearch', function() {
    return {
        'restrict': 'E',
        'scope': {
            'name': '@menuSearchName',
            'label': '@menuSearchLabel',
            'ctrl': '=menuSearchCtrl',
        },
        'template': '' +
        '<div layout="row">' + 
            '<md-input-container>' + 
                '<label>{{ label }}</label>' + 
                '<input ' + 
                    'disabled ' + 
                    'value="{{ ctrl.query[name] | date }}" />' + 
            '</md-input-container>' + 
            '<md-icon md-prevent-menu-close="md-prevent-menu-close" data-ng-click="edit = !edit">edit</md-icon>' + 
            '<md-icon md-prevent-menu-close="md-prevent-menu-close" data-ng-show="ctrl.query[name]" data-ng-click="ctrl.query[name] = null; edit= false; ctrl.load()">close</md-icon>' + 
        '</div>' + 

        '<div class="menuCal" ng-if="edit">' + 
            '<md-datepicker ' + 
                'md-is-open="edit" ' + 
                'ng-model="ctrl.query[name]"' + 
                'ng-change="$parent.edit= false; ctrl.load()">' + 
                
            '</md-datepicker>' + 
        '</div>',
        'controller': function($scope, $http) {
            var fKey = $scope.name + '_id';
            $scope.ctrl.eqFields.push({
                'localName': fKey,
                'remoteName': fKey,
                'op': 'eq'
            });
            
            if($scope.ctrl.query[fKey]) {
                $scope.selectedItem = {'name': $scope.ctrl.query[fKey]};
                $scope.results = [
                    $scope.selectedItem
                ];
            }

            $scope.update = function() {
                if($scope.selectedItem) {
                    $scope.ctrl.query[fKey] = $scope.selectedItem.id; 
                } else {
                    $scope.ctrl.query[fKey] = null;
                }
                $scope.ctrl.query.page = 1;
                $scope.ctrl.load();
            };

            $scope.search = function() {
                var params = {
                    'q': {
                        'filters': [{
                            'name': 'name',
                            'op': 'ilike',
                            'val': '%' + $scope.searchText + '%'
                        }]
                    }
                };

                $scope.results = $http({'method': 'GET', 'url': '/api/v1/admin/' + $scope.name, 'params': params}).then(
                    function(response) {
                        return response.data.objects;
                    }
                );
            };
        }
    };
});

